import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { FeApi, useInjectFeApiContext } from '@/api/fe-api';
import { PageUrlKey } from '@/entities/page-url-key';
import { useMe } from '@/hooks/use-me';

import { defaultLandingPageReverseMapper } from '../mappers/display-preferences.mapper';

export namespace UpdateDisplayPreferences {
  export type Input = {
    defaultLandingPage: PageUrlKey;
  };

  export type Output = void;

  export function useMutation() {
    const { uuid: userUuid } = useMe();
    const updatePreferences = useInjectFeApiContext(
      FeApi.usersV1PreferencesPartialUpdate,
    );

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(input): Promise<Output> {
        if (!userUuid) {
          throw new Error('User UUID is undefined');
        }

        await ok(
          updatePreferences({
            userUuid,
            patchedUpdateUserPreferencesInputRequest: {
              default_landing_page: defaultLandingPageReverseMapper(
                input.defaultLandingPage,
              ),
            },
          }),
        );
      },
    });
  }
}
